import NewSlotForm from './NewSlotForm';

export default NewSlotForm;
